mutation downgradeToFreeLight($input: DowngradeToFreeLightInput!) {
  downgradeToFreeLight(input: $input)
}
